import { alpha, createTheme, styled } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import React from 'react';
import { CustomTheme } from './theme.types';

export const theme = createTheme({
  palette: {
    background: {
      blueGradient: 'linear-gradient(180deg,#003d5b 0%,#195474  100%)',
    },
  },
  mixins: {
    MuiDataGrid: {
      containerBackground: '#f5f5f5', // grey 100
    },
  },
});

export const colors = theme.palette;

// Workframe layout
export const headerHeight = theme.spacing(8); //'60px'
export const sidebarCollapsedWidth = '75px';
export const gridContainerMinWidth = '1200px';
export const workframeBorderStyle = `1px solid ${colors.grey[300]}`;

// main nav
export const mainNavStyles = {
  navItem: {
    active: {
      background: alpha('#E6F4FF', 0.5),
      borderRight: `3px solid ${colors.primary.main}`,
      color: colors.primary.dark, //text/primaryDark
      '&:hover': {
        background: alpha('#E6F4FF', 0.3),
      },
    },
  },
};

export const Link = styled(RouterLink)(({ theme }) => ({
  color: theme.palette.primary.dark,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
  '&.active': {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
}));
